import { getSuperfeaturedUsers } from '@/api/community';

const defaultState = () => ({
  loading: false,
  data: [],
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setData(state, data) {
      state.data = data;
    },
    reset(state) {
      Object.assign(state, defaultState());
    },
  },
  actions: {
    get: async ({ commit, dispatch }) => {
      try {
        commit('setLoading', true);
        const { data } = await getSuperfeaturedUsers();
        commit('setData', data);
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading,
    data: state => state.data || [],
  },
};
